import SessionEventProto from "../session-event-proto"
import {EntityType} from "../../gd/const/item";

type Header = {
    id              : ID
    isBulkUpdate    : boolean
}

// const debug = false
const debug = "SessionEventHourlyCostHistory"

export default class SessionEventHourlyCostHistory extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)

        this.header     = {
            id              : sessionEvent.hourlyCostHistory.id,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    process() {
        if (this.isDifferentCompany()) return false

        const data = _.cloneDeep(this.data)

        debug && console.log(debug, 'process', data.type, data)

        gd.modelBus.newUpdate(EntityType.HOURLY_COST_HISTORY, this.method, this.header.id, data, this.header)
    }
}
